// Vendor Libs
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export function changePassword(oldClientSecret, newClientSecret) {
    return (dispatch) => {
        const dispatchFetched = () => {
            dispatch({
                type: 'CHANGE_PASSWORD_FETCH_FULFILLED',
                payload: {
                    error: null,
                    fetched: true,
                    fetching: false,
                },
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'CHANGE_PASSWORD_FETCH_REJECTED',
                payload: {
                    fetched: true,
                    fetching: false,
                    error,
                },
            });
        };
        const actionParams = {
            servicesConfig: servicesFormConfig.changePassword,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'CHANGE_PASSWORD_FETCH',
        });

        return actionsServiceCaller(actionParams, {oldClientSecret, newClientSecret});
    };
}

export function clearError() {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_PASSWORD_CLEAR_ERROR',
        });
    };
}

export function changePasswordReset() {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_PASSWORD_RESET',
        });
    };
}
